import React from "react";
import PropTypes from 'prop-types';
import {styled} from '@epic-ui/epic/src/styled-components';
import {connect} from "react-redux";
import {getMessage} from '../common/Message';

const MaintenanceWrapper = styled.div`
    border: 0;
    width: 100%;
    min-height: 600px;
    display: flex;
    justify-content:center;
    align-items: center;
    text-align: center;
`;

MaintenanceWrapper.displayName = 'MaintenanceWrapper';

const mapStateToProps = state => ({
    messages: state.get('localization').get('messageProperties')
});

const Maintenance = ({messages}) => (<MaintenanceWrapper>
    <div>
        <p>{getMessage(messages, 'epic.affiliate.hyperwallet.maintenance.message1')}</p>
        <p>{getMessage(messages, 'epic.affiliate.hyperwallet.maintenance.message2')}</p>
    </div>
</MaintenanceWrapper>);

Maintenance.propTypes = {
    messages: PropTypes.object
};

export default connect(mapStateToProps)(Maintenance);
